<mat-dialog-content>
	<p>
		{{message}}
	</p>
</mat-dialog-content>
<mat-dialog-actions align="center">
	<button mat-raised-button class="btn btn-primary custom_btn" (click)="onConfirmClick()" tabindex="1">{{confirmButtonText}}</button>
	<button mat-raised-button mat-dialog-close tabindex="-1" class="btn btn-default custom_btn">{{cancelButtonText}}</button>
</mat-dialog-actions>